import { isNil } from 'lodash-es';
import { z } from 'zod';

export const getCartQuantitySchema = (
  stock: Record<string, number>,
  minimumQuantity: number,
) =>
  z.object({
    comment: z.string().nullish(),
    quantity: z
      .record(z.string(), z.coerce.number<number>().optional())
      .superRefine((quantities, ctx) => {
        Object.entries(quantities).forEach(([id, quantity]) => {
          const maxVal = stock[id];
          if (
            !isNil(quantity) &&
            !isNil(maxVal) &&
            (quantity > maxVal || quantity < minimumQuantity)
          ) {
            ctx.addIssue({
              code: 'custom',
              message: 'app.purchase.cart.errors.invalid_quantity',
              path: [id],
              fatal: true,
            });
          }
        });
      }),
  });
